import React from 'react';

import Group from '@pb/kit-component-group';
import Icon, {Icons} from '@pb/kit-component-icon';
import Typography from '@pb/kit-component-typography';

import {docLink, instructionsList, instructionsSection} from '../confirm-login-fields.module.styl';
import {ATTRIBUTE_INSTRUCTIONS} from '../utils/attribute-instructions-data';

type AttributeConfigInstructionsProps = {
    providerId: string | null,
};

export const AttributeConfigInstructions: React.FC<AttributeConfigInstructionsProps> = ({providerId}) => {
    const provider = ATTRIBUTE_INSTRUCTIONS[providerId ?? 'other'] ?? ATTRIBUTE_INSTRUCTIONS.other;

    function renderStep(step: string) {
        return step.split(/(`[^`]+`)/g).map((part, i) =>
            part.startsWith('`') && part.endsWith('`')
                ? <b key={i}>{part.slice(1, -1)}</b>
                : part,
        );
    }

    return (
        <div className={instructionsSection}>
            <Typography variant="body-level-1" style={{fontWeight: 600}}>
                How to configure attribute mapping in your Identity Provider
            </Typography>
            <Group direction="v" gap="s" style={{paddingTop: 12}}>
                <ol className={instructionsList}>
                    {provider.steps.map((step, index) => (
                        <li key={index}>{renderStep(step)}</li>
                    ))}
                </ol>
                {provider.docUrl ? (
                    <a
                        href={provider.docUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={docLink}>
                        {provider.docLabel}
                        <Icon type={Icons.EXTERNAL_LINK} size="Size_12"/>
                    </a>
                ) : null}
                {provider.pdfGuide ? (
                    <a
                        href={provider.pdfGuide.url}
                        download={true}
                        className={docLink}>
                        {provider.pdfGuide.label}
                        <Icon type={Icons.DOWNLOAD} size="Size_12"/>
                    </a>
                ) : null}
            </Group>
        </div>
    );
};
